<template>
  <div
    class="user-item"
    :class="{
      'user-item--disabled': coaching >= limit,
    }"
    @click="userClicked"
  >
    <div class="user-item__meta">
      <p
        v-if="limit"
        class="user-item__balance mb-0"
        :class="{ 'user-item__balance--disabled': coaching >= limit }"
      >
        {{ coachingText }} {{ coaching }} {{ ofText }} {{ limit }}
      </p>
      <User :account="account" :name="name" :secondaryText="position" />
    </div>
    <div v-if="selected" class="user-item__selected-container">
      <v-icon
        data-testid="userItem-icon-selected"
        class="mr-2"
        small
        color="blue"
      >
        mdi-check-circle
      </v-icon>
    </div>
  </div>
</template>

<script>
import User from '@/components/Core/User.vue'

export default {
  name: 'UserItem',

  components: {
    User,
  },

  props: {
    account: { type: Object, required: true },
    name: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      required: false,
    },
    selected: {
      type: Boolean,
      required: false,
    },
    coaching: {
      type: Number,
      required: false,
      default: function() {
        return 0
      },
    },
    limit: {
      type: Number,
      required: false,
    },
    ofText: {
      type: String,
      required: false,
    },
    coachingText: {
      type: String,
      required: false,
    },
  },

  methods: {
    userClicked: function() {
      if (this.limit && this.coaching >= this.limit) return

      this.$emit('userClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.user-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  padding: 12px 8px;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: $color-blue-grey-lighten3;
  }

  &--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.user-item__meta {
  flex: 1;
}

.user-item__selected-container {
  text-align: right;
  position: absolute;
  right: 16px;
  top: 30%;
}

.user-item__balance {
  color: #a0aec0;
  font-size: 10px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 4px;
  margin-left: 48px;

  &--disabled {
    color: #e12e2d;
  }
}

.user-item__balance {
  .user__avatar {
    margin-top: -10px !important;
  }
}
</style>
